<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2" @click="addOrEdit" :loading="btnLoading">保存</el-button>
      <!-- <el-button  @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="com" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="单位代号">
              <el-input v-model="com.comcode" :maxlength="20" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="margin-left: 80px;">
            <el-form-item label="单位全称">
              <el-input v-model="com.comfullname" :maxlength="80" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false">
      </vggrid>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: "comTypeApply",
    data () {
      return {
        comid: this.$route.params.form.comid,
        type: Number(this.$route.params.type),
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { type: 'radio',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'syscodename', fieldtype: 'C', title: '名称',calculExpr:''}
        ],
        com: {},
        btnLoading: false
      }
    },
    async activated() {
      this.init()
      await this.getCom()
      await this.getList()
    },
    created () {
    },
    watch: {
    },
    filters: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async init() {
        this.comid = this.$route.params.form.comid
        this.type = Number(this.$route.params.type)
        this.list = []
      },
      async getCom() {
        let data = await request({
          method: 'get',
          url: '/ywgl/com/getComById',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        if (data.length===1) {
          this.com = data[0]
        }
      },
      async getList() {
        this.list = await request({
          url: '/ywgl/com/getCanbeSelectedComTypesList',
          method: "get",
          params: {comid:this.com.comid}
        })
        console.log(this.list)
      },
      async addOrEdit () {
        let row = this.$refs.xGrid.$refs.xGrid.getRadioRow()
        console.log(row)
        let model = {
          comid: this.com.comid,
          userid: this.$store.getters.loginUser.userid,
          comtype: row.syscodeval
        }
        let data = await request({
          url: '/ywgl/com/saveComType',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.$message.success('申请成功')
          await this.getList()
        } else {
          this.$message.error('申请失败')
        }
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'comTypeApplyIndex'})
      }
    }
  }
</script>

<style scoped>

</style>
